
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homepage/[sc_groups]",
      function () {
        return require("private-next-pages/homepage/[sc_groups].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/homepage/[sc_groups]"])
      });
    }
  